<template>
  <div>
    <div class="home-video-consult" :style="{ width, height, background: bg, 'border-radius': radius }"
      @click="toLink(item)">
      <img :src="item.icon" v-if="item.icon" alt="">
      <div class="intro">
        <div class="title">
          {{ item.title }}
        </div>
        <div class="desc" v-if="item.desc">
          {{ item.desc }}
        </div>
      </div>
    </div>
    <el-dialog title="留言咨询" :visible.sync="showLeaveDialog">
      <p style="margin-bottom: 20px;">当前时间段仅支持留言咨询</p>
      <el-form :model="leaveForm" :rules="leaveRule" label-position="left" ref="leaveFormRef" :disabled="leaveLoading">
        <el-form-item label="联系方式:" prop="leavePhone">
          <el-input @input="verifyPhone" style="width: 300px;" v-model="leaveForm.leavePhone" :maxlength="11"
            placeholder="请填写联系方式">
          </el-input>
        </el-form-item>
        <el-form-item label="留言内容:" prop="leaveMessage">
          <el-input v-model="leaveForm.leaveMessage" :show-word-limit="true" :autosize="{ minRows: 4, maxRows: 4 }"
            :maxlength="300" type="textarea" resize="none" placeholder="请填写留言内容"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="confirmLeave(false)" :loading="leaveLoading">取 消</el-button>
        <el-button type="primary" @click="confirmLeave(true)" :loading="leaveLoading">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { v4 as generateUUID } from 'uuid'
import { getDeviceRule, confirmLeaveMessage } from '@/lib/request'

export default {
  props: {
    item: {
      type: Object,
      default: () => {
        return {
          title: '实时咨询律师',
          path: '/video',
          icon: '/img/ui/videohome/icon_videozixun_90.png'
        }
      }
    },
    width: {
      type: String,
      default: '2.88rem'
    },
    height: {
      type: String,
      default: '1.82rem'
    },
    bg: {
      type: String,
      default: ''
    },
    radius: {
      type: String,
      default: '0'
    }
  },
  data () {
    return {
      showLeaveDialog: false, // 是否显示留言弹窗
      leaveForm: {
        leaveMessage: '', // 留言内容
        leavePhone: '', // 留言电话
      },
      leaveRule: {
        leavePhone: [
          { required: true, message: '请填写联系方式', trigger: 'blur' },
        ],
        leaveMessage: [
          { required: true, message: '请输入留言内容', trigger: 'blur' },
        ]
      },
      leaveLoading: false,
      leaveTimer: null,
    }
  },
  mounted () {
    if (this.$socket) {
      // 监听留言事件,判断是否留言成功
      this.$socket.on('sendMsg', async (data) => {
        if (data.type === 'leaveMessage') {
          const res = await confirmLeaveMessage({ messageUUID: data.uuid, phone: data.attribute.leaveMessage.phone, content: data.attribute.leaveMessage.message })
          if (res) {
            if (this.leaveTimer) {
              clearTimeout(this.leaveTimer)
              this.leaveTimer = null
            }
            this.leaveLoading = false
            this.showLeaveDialog = false
            this.$message.success = '留言成功'
          }
        }
      })
    }
  },
  methods: {
    async toLink (item) {
      try {
        const res = await getDeviceRule(window.localStorage.code)
        if (res && res.open) {
          const time = new Date()
          if (time.getHours() >= 21 || time.getHours() < 9) { // 下午九点到次日九点， 只允许留言咨询
            this.showLeaveDialog = true;
          } else {
            this.$router.push(item.path)
          }
        } else {
          this.$router.push(item.path)
        }
      } catch (error) {
        console.log(item.path, 'err', error)
        this.$router.push(item.path)

      }
    },
    // 手机号校验
    verifyPhone () {
      if (!/^1[0-9]{10}$/.test(this.leaveForm.leavePhone))
        this.leaveForm.leavePhone = this.leaveForm.leavePhone.replace(/[^\d]/g, '');
    },
    // 留言表单提交
    confirmLeave (bool) {
      if (bool) {
        this.$refs.leaveFormRef.validate((valid) => {
          if (valid) {
            this.leaveLoading = true;
            // 提交留言
            const msg = {
              uuid: generateUUID(),
              content: '',
              attribute: {
                leaveMessage: {
                  phone: this.leaveForm.leavePhone,
                  message: this.leaveForm.leaveMessage
                }
              },
              type: 'leaveMessage',
              roomName: window.roomName,
              sendTime: new Date(),
            };
            this.$socket && this.$socket.emit("sendMsg", msg);
            if (this.leaveTimer) {
              clearTimeout(this.leaveTimer)
              this.leaveTimer = null
            }
            this.leaveTimer = setTimeout(() => {
              if (this.showLeaveDialog && this.leaveLoading) {
                this.$message.error('留言提交等待超时');

                this.leaveLoading = false
              }
            }, 30000)
          }
        })
      } else {
        this.showLeaveDialog = false;
        this.$refs.leaveFormRef.resetFields()
      }
    },
  }

}
</script>
<style lang="stylus">
.home-video-consult
  background-image linear-gradient(-180deg, #3079ff 0%, #599bff 100%)
  color #fff
  font-size 24px
  display flex
  flex-direction column
  justify-content center
  align-items center
  img
    width 0.9rem
    margin-bottom 0.05rem
</style>
